<div mat-dialog-content>
    <ng-container *ngIf="data.status">
        <div class="text-center">
        <i class="bi bi-check2-circle icon-modal-exito"></i>
        </div>
        <p class="text-center"><strong>Recuperación de contraseña.</strong></p>
        <p class="text-center">{{ data.texto }}</p>
    </ng-container>
    <ng-container *ngIf="!data.status">
        <div class="text-center">
            <i class="bi bi-x-circle icon-modal-error"></i>
        </div>
        <p class="text-center"><strong>Lo sentimos</strong></p>
        <p class="text-center">Hemos encontrado un error.</p>
        <p class="text-center">{{ data.texto }}</p>
    </ng-container>
</div>
<mat-dialog-actions align="center">
        <button type="button"class="btn btn-success btn-md mr-0 mr-md-3 mb-3 mb-md-0 m-3 text-center" (click)="cerrarModal()">Cerrar</button>
  </mat-dialog-actions>
